export class NotificationItem {
    public title: string
    public description: string
    public active: boolean
    constructor(title: string, description: string) {
        this.title = title
        this.description = description
        this.active = true
    }
}
